import React from 'react';
import IconButton from './IconButton';

const FilterToggleButtons = ({ filters }) => (filters.map(({
  active, icon, key, messageId, onClick,
}) => (
  <IconButton
    key={`aridhia_filter_toggle_${key}`}
    active={active}
    iconName={icon}
    iconOnly
    messageId={messageId}
    onClick={onClick}
    toggle
  />
)));

export default FilterToggleButtons;
